module.exports = __webpack_public_path__ + "img/s5_stepimg02-s.b9730f03.png";